module.exports = __webpack_public_path__ + "img/im.f36fc8a2.png";